module.exports = __webpack_public_path__ + "img/blocked.0b8a7b9a.svg";